import React from "react";
import styled from "styled-components";

interface TabContentWrapperProps {
  isActive: boolean;
  tabName: string;
  children: React.ReactNode;
}

const Wrapper = styled.div<{
  isActive: boolean;
}>`
  display: ${({ isActive }) => (isActive ? "flex" : "none")};
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
`;

const TabContentWrapper: React.FC<TabContentWrapperProps> = ({ isActive, tabName, children }) => {
  return (
    <Wrapper 
      isActive={isActive}
      data-tab-name={tabName}
      data-tab-active={isActive ? "true" : "false"}
    >
      {children}
    </Wrapper>
  );
};

export default TabContentWrapper;
